ace.define("ace/theme/tiivii-dark", ["require", "exports", "module", "ace/lib/dom"], function(acequire, exports, module) {
exports.isDark = true;
exports.cssClass = "ace-tiivii-dark";
exports.cssText = ".ace-tiivii-dark .ace_gutter {\
background: #1e1e1e;\
color: #858585\
}\
.ace-tiivii-dark .ace_print-margin {\
width: 1px;\
background: #3c3c3c\
}\
.ace-tiivii-dark {\
background-color: #1e1e1e;\
color: #d4d4d4\
}\
.ace-tiivii-dark .ace_cursor {\
color: #aeafad\
}\
.ace-tiivii-dark .ace_marker-layer .ace_selection {\
background: #264f78\
}\
.ace-tiivii-dark.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #1e1e1e;\
}\
.ace-tiivii-dark .ace_marker-layer .ace_step {\
background: rgb(102, 82, 0)\
}\
.ace-tiivii-dark .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid #515151\
}\
.ace-tiivii-dark .ace_marker-layer .ace_active-line {\
background: #2a2a2a\
}\
.ace-tiivii-dark .ace_gutter-active-line {\
background-color: #2a2a2a\
}\
.ace-tiivii-dark .ace_marker-layer .ace_selected-word {\
border: 1px solid #264f78\
}\
.ace-tiivii-dark .ace_invisible {\
color: #52524d\
}\
.ace-tiivii-dark .ace_entity.ace_name.ace_tag,\
.ace-tiivii-dark .ace_keyword,\
.ace-tiivii-dark .ace_meta.ace_tag,\
.ace-tiivii-dark .ace_storage {\
color: #569cd6\
}\
.ace-tiivii-dark .ace_punctuation,\
.ace-tiivii-dark .ace_punctuation.ace_tag,\
.ace-tiivii-dark .ace_paren {\
color: #d4d4d4\
}\
.ace-tiivii-dark .ace_constant.ace_character,\
.ace-tiivii-dark .ace_constant.ace_numeric,\
.ace-tiivii-dark .ace_constant.ace_other {\
color: #b5cea8\
}\
.ace-tiivii-dark .ace_constant.ace_language {\
color: #569cd6\
}\
.ace-tiivii-dark .ace_invalid {\
color: #f8f8f0;\
background-color: #f92672\
}\
.ace-tiivii-dark .ace_invalid.ace_deprecated {\
color: #f8f8f0;\
background-color: #ae81ff\
}\
.ace-tiivii-dark .ace_support.ace_constant,\
.ace-tiivii-dark .ace_support.ace_function {\
color: #4ec9b0\
}\
.ace-tiivii-dark .ace_fold {\
background-color: #9cdcfe;\
border-color: #d4d4d4\
}\
.ace-tiivii-dark .ace_storage.ace_type,\
.ace-tiivii-dark .ace_support.ace_class,\
.ace-tiivii-dark .ace_support.ace_type {\
font-style: italic;\
color: #4ec9b0\
}\
.ace-tiivii-dark .ace_entity.ace_name.ace_function,\
.ace-tiivii-dark .ace_entity.ace_other,\
.ace-tiivii-dark .ace_entity.ace_other.ace_attribute-name,\
.ace-tiivii-dark .ace_variable {\
color: #9cdcfe\
}\
.ace-tiivii-dark .ace_variable.ace_parameter {\
font-style: italic;\
color: #d19a66\
}\
.ace-tiivii-dark .ace_string {\
color: #ce9178\
}\
.ace-tiivii-dark .ace_comment {\
color: #6a9955\
}\
.ace-tiivii-dark .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\
}";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});
